import { Injectable } from '@angular/core';
import * as ac from '@rezonant/actioncable';
import { AppConfig } from './app-config';

class StubChannel implements ac.Channel {
    unsubscribe() {}
    perform(action: string, data: {}) {}
    send(data: Object) { return false; }
}

@Injectable()
export class ActionCable {

    constructor(
        private appConfig : AppConfig
    ) {
    }

    private cable : ac.Cable;
    private _url = null;

    get url() {
        return this.appConfig.cableUrl;
    }

    subscribe(channel : string|ac.ChannelNameWithParams, createMixin : ac.CreateMixin): ac.Channel {

        if (typeof window === 'undefined')
            return new StubChannel();
        
        if (!this.cable) {
            this.cable = ac.createConsumer(this.url);
        }
        return this.cable.subscriptions.create(channel, createMixin);
    }
}